import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { type SxProps } from '@mui/material';

const styles: Record<string, SxProps> = {
  cardSetup: {
    display: 'grid',
    gridTemplateAreas: '"Scenario" "Description"',
    gridTemplateColumns: 'auto',
    userSelect: 'none',
    minHeight: '100px',
    p: '1em',
    typography: 'body2',
    gap: '1em',
  },
  picture: {
    gridArea: 'Scenario',
    float: 'left',
    p: 0,
    marginRight: '1em',
  },
  scenario: {
    gridArea: 'Scenario',
    alignItems: 'center',
  },
  description: {
    gridArea: 'Description',
    overflowY: 'auto',
    bgcolor: 'info.light',
    color: 'info.contrastText',
    p: '1em'
  },
};

interface Props {
  imgUrl?: string | undefined;
  background?: string | JSX.Element;
  content: string | JSX.Element;
  description: string | JSX.Element;
}

export const TagScenario = (props: Props) => {
  const {
    imgUrl = undefined,
    background = undefined,
    content,
    description,
  } = props;

  return (
    <Paper sx={styles.cardSetup} elevation={2}>
      <Box sx={styles.scenario}>
        {imgUrl ? (
          <Box
            component='img'
            sx={styles.picture}
            alt='Patient'
            src={imgUrl as string}
          />
        ) : null}
        {background ? (
          <Box>
            <i>{background} </i>
          </Box>
        ) : null}
        <Box>
          {content}
        </Box>
      </Box>
      <Paper elevation={1} sx={styles.description}>
        {description}
      </Paper>
    </Paper>
  );
};
